import { Link } from 'react-router-dom'

import { useOutreachByFilter } from '../../../engage/campaigns/queries'
import { OutreachCard } from './outreach-card'
import { OutreachListSkeleton } from './outreach-list-skeleton'
import { OutreachSection } from './outreach-section'

function OngoingOutreach() {
  const ongoingOutreach = useOutreachByFilter({
    filter: 'ongoing',
    permission: 'associate',
  })

  if (ongoingOutreach.data) {
    const outreachList = ongoingOutreach.data?.pages.flatMap((d) => d.data)

    return outreachList?.length ? (
      <OutreachSection title="Ongoing Outreach">
        <div className="grid grid-cols-2 gap-3">
          {outreachList.map((outreach) => {
            // required since we don't discriminate campaign return
            if (outreach.className === 'Broadcast') return null

            return (
              <Link
                key={outreach.objectId}
                to={`/tabs/clients/outreach/${outreach.objectId}`}
                className=""
              >
                <OutreachCard
                  key={outreach.objectId}
                  clientCount={outreach.stats.clientCount}
                  name={outreach.name}
                />
              </Link>
            )
          })}
        </div>
      </OutreachSection>
    ) : null
  }

  return <OutreachListSkeleton />
}

export { OngoingOutreach }
